var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepTwoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12035_24811)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.05784 16V15.388L12.5498 11.968C12.8698 11.656 13.1098 11.384 13.2698 11.152C13.4298 10.912 13.5378 10.688 13.5938 10.48C13.6498 10.272 13.6778 10.076 13.6778 9.892C13.6778 9.404 13.5098 9.02 13.1738 8.74C12.8458 8.46 12.3578 8.32 11.7098 8.32C11.2138 8.32 10.7738 8.396 10.3898 8.548C10.0138 8.7 9.68984 8.936 9.41784 9.256L8.80584 8.728C9.13384 8.344 9.55384 8.048 10.0658 7.84C10.5778 7.632 11.1498 7.528 11.7818 7.528C12.3498 7.528 12.8418 7.62 13.2578 7.804C13.6738 7.98 13.9938 8.24 14.2178 8.584C14.4498 8.928 14.5658 9.332 14.5658 9.796C14.5658 10.068 14.5258 10.336 14.4458 10.6C14.3738 10.864 14.2378 11.144 14.0378 11.44C13.8458 11.728 13.5618 12.056 13.1858 12.424L9.98184 15.568L9.74184 15.232H14.9498V16H9.05784Z",
    fill: "#4C5862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12035_24811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepTwoIcon);
export default __webpack_public_path__ + "static/media/stepTwoIcon.1a512a88748ae106afc559764a69daf5.svg";
export { ForwardRef as ReactComponent };